var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _vm.estimatedAnnualFeeBtnShow
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.ProductQuoteMcdSave,
                          expression: "ProductQuoteMcdSave",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateQuotation("save")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("apply.annualTotalCostSave")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.historyBack },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "applyInfoForm",
              staticClass: "topform",
              attrs: {
                "label-width": "120px",
                model: _vm.headData,
                "label-position": "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单据编号" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.applyNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "applyNo", $$v)
                              },
                              expression: "headData.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "subject", $$v)
                              },
                              expression: "headData.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "name", $$v)
                              },
                              expression: "headData.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: "选择日期",
                              disabled: "",
                            },
                            model: {
                              value: _vm.headData.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "createDate", $$v)
                              },
                              expression: "headData.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "产品报价明细", name: "first" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "flex", justify: "start", align: "middle" },
                },
                [
                  _vm.$route.query.roundStatus == "2" && !_vm.isShowBtn
                    ? _c(
                        "el-upload",
                        {
                          staticClass: "apply-import-button",
                          attrs: {
                            "on-error": _vm.importDetailError,
                            "on-success": _vm.importDetailSuccess,
                            "before-upload": _vm.beforeUpload,
                            action: _vm.importDetailUrl,
                            multiple: "false",
                            headers: _vm.headers,
                            "show-file-list": false,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "mini", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("common.import")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isShowBtn
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.exportDetails },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.export")))]
                      )
                    : _vm._e(),
                  !_vm.isShowBtn
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "(仅导出非标准线路运费为否的行项目，导入可更新预估年总费用)"
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "ux-grid",
                {
                  ref: "applyProductTableDataRef",
                  attrs: {
                    data: _vm.applyProductTableData,
                    "keep-source": "",
                    "row-class-name": _vm.tableRowClassName,
                    "highlight-current-row": "",
                    "max-height": "550",
                    "show-overflow": "tooltip",
                  },
                  on: { "sort-change": _vm.changeSort },
                },
                [
                  !_vm.estimatedAnnualFeeEditFlag
                    ? _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "操作",
                          "min-width": "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("i", {
                                    class:
                                      scope.row.colour == "Y"
                                        ? "el-icon-edit-outline fff"
                                        : "el-icon-edit-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(scope)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2651102388
                        ),
                      })
                    : _vm._e(),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "序号",
                      type: "index",
                      width: "60",
                    },
                  }),
                  _vm._l(_vm.columns, function (item, index) {
                    return _c("ux-table-column", {
                      key: index,
                      attrs: {
                        align: "center",
                        resizable: "",
                        field: item.prop,
                        title: item.label,
                        sortable: "",
                        "min-width": item.width,
                      },
                    })
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      resizable: "",
                      field: "isSpecialFreight",
                      title: "非标准线路运费",
                      sortable: "",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("setIsSpecialFreight")(
                                    scope.row.isSpecialFreight
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._l(_vm.columns1, function (item, index) {
                    return _c("ux-table-column", {
                      key: index,
                      attrs: {
                        align: "center",
                        resizable: "",
                        field: item.prop,
                        title: item.label,
                        sortable: "",
                        "min-width": item.width,
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _c(
            "el-form",
            { ref: "formTable", attrs: { model: _vm.formTable, inline: "" } },
            [
              _c(
                "el-table",
                {
                  ref: "tableDataRef",
                  attrs: {
                    data: _vm.formTable.tableData,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "470",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "supplierName",
                      label: "供应商",
                      "min-width": "160px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "eightBitCode",
                      label: "8位码",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "eightBitCodeName",
                      label: "8位码名称",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "pickupPoint",
                      label: "发货市",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "dcName",
                      label: "到货仓库",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "temperatureI18n",
                      label: "温区",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "effectiveBeginDate",
                      label: "有效开始日期",
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.effectiveBeginDate,
                                    "YYYY-MM-DD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "isSpecialFreight",
                      label: "非标准线路运费",
                      formatter: _vm.formatisSpecial,
                      "min-width": "150px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "transportaionMethod",
                      label: "运输方式",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "lineUnit",
                      label: "结算单位",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "linePrice",
                      label: "线路价格",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "productPrice",
                      label: "产品运费（不含税）",
                      "min-width": "180px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "estimatedAnnualFee",
                      label: _vm.$t("apply.estimatedAnnualTotalCost"),
                      width: "160px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "tableData." +
                                    scope.$index +
                                    ".estimatedAnnualFee",
                                  rules: _vm.rules.estimatedAnnualFee,
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.estimatedAnnualFee,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "estimatedAnnualFee",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.estimatedAnnualFee",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "changeRate",
                      label: "价格变化",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "currencyCode",
                      label: "币种",
                      "min-width": "100px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "leadTime",
                      label: "LeadTime",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "externalPackagingLength",
                      label: "外包装长(cm)",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "externalPackagingWidth",
                      label: "外包装宽(cm)",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "externalPackagingHeight",
                      label: "外包装高(cm)",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "externalPackagingNetweight",
                      label: "外包装净重(kg)",
                      "min-width": "130px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "externalPackagingGrossweight",
                      label: "外包装毛重(kg)",
                      "min-width": "130px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "palletLayerNumber",
                      label: "每Pallet层数",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "palletLayerBoxNumber",
                      label: "每层箱数",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "palletItemsLength",
                      label: "托盘上物品长度(cm)",
                      "min-width": "170px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "palletItemsWidth",
                      label: "托盘上物品宽度(cm)",
                      "min-width": "170px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "palletItemsHeight",
                      label: "托盘上物品高度(cm)",
                      "min-width": "170px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "remarks",
                      label: "备注",
                      "min-width": "120px",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "custom",
                      prop: "sourcingProductStatus",
                      label: "报价确认审批状态",
                      "min-width": "170px",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }